/* eslint-disable import/prefer-default-export */
import React from 'react'
import { SvgIconProps } from './SvgIconProps'

export const Play: React.FC<SvgIconProps> = ({ size = '24px', color = 'currentColor' }) => {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M18.6639 11.4337L9.02413 6.08655C8.92057 6.02974 8.80335 5.99991 8.6841 6C8.56485 6.00009 8.44769 6.03012 8.34422 6.08709C8.24076 6.14407 8.15457 6.22602 8.09419 6.32484C8.03382 6.42366 8.00135 6.53592 8 6.6505V17.3495C8.00135 17.4641 8.03382 17.5763 8.09419 17.6752C8.15457 17.774 8.24076 17.8559 8.34422 17.9129C8.44769 17.9699 8.56485 17.9999 8.6841 18C8.80335 18.0001 8.92057 17.9703 9.02413 17.9134L18.6639 12.5663C18.7663 12.5081 18.8511 12.4253 18.9101 12.326C18.969 12.2267 19 12.1143 19 12C19 11.8857 18.969 11.7733 18.9101 11.674C18.8511 11.5747 18.7663 11.4919 18.6639 11.4337Z"
      fill={color}
    />
  </svg>
}
